import { Flex } from '@chakra-ui/react';
import { DiffModal } from '../common/DiffModal';
import { RadioDisplay } from './RadioDisplay';

interface Props {
  value?: string;
  previousValue?: string | null;
  onClose: () => void;
  fieldName: string;
}

export const RadioDiffModal = ({
  value,
  previousValue,
  onClose,
  fieldName
}: Props) => {
  const prevZeroState = !previousValue;
  const currentZeroState = !value;

  const zeroState = (
    <Flex padding={2} backgroundColor="surfaceTertiaryFill">
      No {fieldName} provided
    </Flex>
  );

  return (
    <DiffModal onClose={onClose}>
      {/* ----- Left side ----- */}
      <DiffModal.LeftSide label={fieldName}>
        {prevZeroState ? zeroState : <RadioDisplay value={previousValue} />}
      </DiffModal.LeftSide>

      {/* ----- Right side ----- */}
      <DiffModal.RightSide label={fieldName}>
        {currentZeroState ? zeroState : <RadioDisplay value={value} />}
      </DiffModal.RightSide>
    </DiffModal>
  );
};
